export const locationsIndexLink = {
  label: 'VIEW ALL',
  path: '/cities'
};

export const aboutUsIndexLink = {
  label: 'VIEW ALL',
  path: '/about'
};
